// extracted by mini-css-extract-plugin
module.exports = {"desktop":"1200px","tablet":"640px","mobile":"0"};